import { Component, Optional, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'app/api.service';
import { AdminService } from 'app/admin.service';
import { CreateVoucherPostingDialogComponent } from 'app/create-voucher-posting-dialog/create-voucher-posting-dialog.component';
import { Router } from '@angular/router';
import { FileShowModalComponent } from 'app/file-show-modal/file-show-modal.component';
import { CreateVoucherPostingPreviewComponent } from 'app/create-voucher-posting-preview/create-voucher-posting-preview.component';
import { ActivatedRoute } from '@angular/router';
import { AuditDialogComponent } from 'app/audit-dialog/audit-dialog.component';
import { HighlightService } from 'app/highlight.service';
import { FinancialYearService } from 'app/financial-year.service';
import { Subscription } from 'rxjs';
import { VoucherFileModalComponent } from 'app/voucher-file-modal/voucher-file-modal.component';

@Component({
  selector: 'app-voucher-posting',
  templateUrl: './voucher-posting.component.html',
  styleUrls: ['./voucher-posting.component.scss']
})
export class VoucherPostingComponent {
  data: any[]= [];
  type: any;
  update: string;
  test: boolean = false;
  hostname: any;
  pdfdata:any;
  obdata:any[];
  enforce_match:any;
  company_wise:any;
  branch_wise:any;
  is_show:boolean=false;
  name: string;
  access_list: any;
  branchNames: any;
  fullhostname:any;
  offset = 0;
  limit = 100;
  loading = false;
  hasMore = true;
  sortColumns: string[] = [];
  sortDirections: string[] = [];
  layoutType:string;
  is_auditor:boolean=false;
  is_ShowHeader:boolean=false;
  isModal: boolean= false;
  tracedVoucherId: number | null = null;
  injectedVoucherOnce: boolean = false;
  branch_list: any[] = [];
  selectedBranchId: any = '';
  ledgerData: any[] = [];
  selectedLedgerId: any = '';
  ledger_offset = 0;
  ledger_limit = 100;
  ledger_loading = false;
  ledger_hasMore = true;
  filters: any = {};
  searchTerm: string = '';
  ledger_list: any[] = [];
  branch_offset = 0;
  branch_limit = 100;
  branch_hasMore = true;
  branch_loading = false;
  branchSearch = '';
  isSearch = false;
  noRecords = false;
  selectedFinancialYears: string[] = [];
  private fySubscription: Subscription;

  constructor(private apiService: ApiService, private dialog: MatDialog, private router: Router, private adminService: AdminService, private route: ActivatedRoute, public highlightService: HighlightService,
    private financialYearService: FinancialYearService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<VoucherPostingComponent>
  ) { }

  ngOnInit() {
    if (this.dialogData) {
      this.isModal = true;
      console.log('VoucherPostingComponent opened as modal with data:', this.dialogData);
      if (this.dialogData.voucher_posting_id) {
        this.tracedVoucherId = this.dialogData.voucher_posting_id;
        // Don't set highlightService when in modal to avoid interference with background page
        console.log('Traced voucher ID for modal:', this.tracedVoucherId);
      }
    }
    this.layoutType = this.route.snapshot.data['layout'];
    console.log('layoutType',this.layoutType);
    if (this.layoutType === 'centralhub') {
      this.is_ShowHeader = false;
    } else {
      this.is_ShowHeader = true;
    }

    this.fySubscription = this.financialYearService.selectedYears$.subscribe(years => {
      this.selectedFinancialYears = years;
      this.offset = 0;
      this.hasMore = true;
      this.data = [];
      if (this.isModal) {
        this.fetchAllData();
      } else {
        this.fetchData();
      }
    });

    this.openingTrialBalance();
    this.getBranches();
    this.getLedger();
    this.hostname = window.location.hostname;
    this.fullhostname = window.location.origin;
    console.log('hostname',this.fullhostname);
   
    const accessListData = localStorage.getItem('accesslist');
    if (accessListData) {
      this.access_list = JSON.parse(accessListData);
      const branches = this.access_list[0]?.branches || [];
      console.log('Branches:', branches);
      this.is_auditor=this.access_list[0]?.['is_auditor'] ?? 1;
      // alert(this.is_auditor);
      return branches;
    }
     this.companyDetails();
  }

  ngOnDestroy() {
    if (this.fySubscription) {
      this.fySubscription.unsubscribe();
    }
  }

  openFileShowModal(creation_voucher_id: number,voucherTypeId:any) {
    console.log('voucherId',creation_voucher_id);
    console.log('this.data',this.data);
    const voucher = this.data.find((v: any) => v.creation_voucher_id === creation_voucher_id);
    if (!voucher) {
      console.error('Voucher not found with ID:', creation_voucher_id);
      return;
    }
    const vType = voucher.voucher?.voucher_type || voucher.voucher?.name;
    if (['Purchase', 'Sales'].includes(vType)) {
      this.openVoucherFileShowModal(creation_voucher_id, voucherTypeId, voucher.is_audit);
      return;
    }

    const modalRef = this.dialog.open(FileShowModalComponent, {
      width: '1200px',
      height: '600px',
      disableClose: true,
      data: {
        creation_voucher_id: creation_voucher_id,
        name: this.test,
        is_audit: voucher.is_audit,
        voucherType: voucherTypeId,
        isView: true
      }
    });
  }

  openVoucherFileShowModal(id: number, voucherType: any, is_audit: any) {
    this.apiService.getVoucherFiles(id, voucherType).subscribe(
      (response: any) => {
        const modalRef = this.dialog.open(VoucherFileModalComponent, {
          width: '1200px',
          height: '600px',
          data: {
            id: id,
            images: response.status ? response.uploadedFiles : [],
            voucherType: voucherType,
            isViewMode: true
          }
        });
      },
      (error) => {
        console.error("Error fetching voucher files for index:", error);
      }
    );
  }

  form: boolean = true;
  form1: boolean = true;
  fetchData(isSorted = false,sortColumns: string[] = [], sortDirections: string[] = []) {
    if (!this.hasMore || this.loading) return;
    this.loading = true;
    const params: any = {
      offset: this.offset,
      layoutType:this.layoutType,
    };
    if (this.selectedFinancialYears && this.selectedFinancialYears.length > 0) {
      params.financial_years = JSON.stringify(this.selectedFinancialYears);
    }
    if (this.selectedBranchId) {
       params.branch_id = this.selectedBranchId;
     }
     if (this.selectedLedgerId) {
       params.ledger_id = this.selectedLedgerId;
     }
    if (isSorted && sortColumns.length && sortDirections.length) {
      params.columns = sortColumns;
      params.directions = sortDirections;
    }
     if (this.searchTerm) {
      params._search = this.searchTerm; 
    }
    this.apiService.getAllpostedvoucher(params).subscribe(
      (response) => {
        this.data.push(...response.posted_voucher);
        if (this.isModal && this.tracedVoucherId) {
          this.scrollToHighlightedRow();
        }
        this.offset = response.next_offset;
        this.hasMore = response.has_more;
        this.loading = false;
        if (this.data.length >= 1) {
          this.form = true;
          this.form1 = false;
        } else {
          this.form = false;
          this.form1 = true;
        }
        console.log('Data from :', this.data);
        if (this.isModal && this.dialogData?.creation_voucher_id) {
          this.scrollToHighlightedRow();
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  createVoucherPosting(voucherId: number) {
    const dialogRef = this.dialog.open(CreateVoucherPostingDialogComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '100%',
      disableClose: true,
      data: {
        operationType: 'create',
        voucherId: voucherId
      }
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      this.fetchData();
      if (result) {
        console.log('Saved Voucher:', result);
      }
    });
  }

  // deleteItem(itemId: number,i:any): void {
  //   this.apiService.deleteVoucherPosting(itemId).subscribe(
  //     response => {
  //       console.log('Item deleted successfully:', response);
  //       if (response && response.message === 'Voucherposting removed successfully') {
  //         alert('Voucherposting removed successfully');
  //          this.data.splice(i, 1);
  //       }
  //     },
  //   );
  // }
  updateItem(itemId: number): void {
    const voucherToUpdate = this.data.find(item => item.id === itemId);
    this.update = "update";
    const dialogRef = this.dialog.open(CreateVoucherPostingDialogComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '100%',
      disableClose: true,
      data: {
        id: itemId,
        type: this.update,
        voucherType: voucherToUpdate[0].voucher_id,
        voucherNo: voucherToUpdate[0].voucher_no,
        date: voucherToUpdate[0].date,
        upload: voucherToUpdate[0].upload,
        narration: voucherToUpdate[0].narration,
        debitSides: voucherToUpdate[0].dr,
        creditSides: voucherToUpdate[0].cr,
        showInter: voucherToUpdate[0].voucher?.voucher_type
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Voucher updated:', result);
        this.fetchData();
      } else {
        console.log('Modal closed without updating data');
      }
    });
  }
  viewItem(voucherId: number, voucherPostingId: number, auditStatus: number, remark: string, i: any): void {
    const voucher = this.data.find(v => v.creation_voucher_id === voucherId);
    this.update = "view";
    const dialogRef = this.dialog.open(CreateVoucherPostingDialogComponent, {
      width: '95%',
      height: '95%',
      maxWidth: '100%',
      disableClose: true,
      data: {
        id: voucherId,
        type: 'view',
        operationType: 'view',
        voucherType: voucher?.voucher?.id,
        voucherNo: voucher?.voucher_no,
        voucherName: voucher?.voucher_name,
        date: voucher?.date,
        narration: voucher?.narration,
        showInter: voucher?.voucher?.voucher_type,
        approval_status: 'Approved',
        is_audit: voucher?.is_audit
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Voucher view:', result);
      } else {
        console.log('Modal closed without updating data');
      }
    });
  }
  // openPostingView(voucherId: number,voucherPostingId:number,auditStatus:number,remark:string,i:any): void {
  //   const index = this.data.findIndex(d => d.creation_voucher_id === voucherId);
  //   const allData = this.data;
  //   this.apiService.getcreationepostdata(voucherId).subscribe(
  //     (postData) => {
  //       console.log("Data from API1:", postData);
  //       const dialogRef = this.dialog.open(CreateVoucherPostingPreviewComponent, {
  //         width:'850px',
  //         height:'550px',
  //         disableClose: true,
  //         data: {
  //           view: postData,
  //           voucher_posting_id:voucherPostingId,
  //           auditstatus:auditStatus,
  //           remark:remark,
  //           index: index,
  //           allData: allData
  //         },
  //       });
  //      dialogRef.afterClosed().subscribe(result => {
  //        if (result) {
  //          console.log('Saved Voucher:', result);
  //         const updatedVoucher = this.data[i];
  //          console.log('specific posted voucher',updatedVoucher);
  //          if (!updatedVoucher.audit) {
  //            updatedVoucher.audit = {
  //              audit_status: null,
  //              remark: null
  //            };
  //          }
  //          updatedVoucher.is_audit=result.audit;
  //          updatedVoucher.audit.audit_status = result.audit;
  //          updatedVoucher.audit.remark = result.remark;
  //        }
  //        this.highlightService.set(voucherId);
  //       });
  //     },
  //   );
  // }

  downloadpdf(id: number) {
    const postData = {
      creation_id: id,
      domain: this.hostname,
      fulldomain:this.fullhostname
    };
    this.apiService.pdfcontent(postData).subscribe(
      response => {
        this.pdfdata = response;
        console.log('pdf contenet', this.pdfdata);
        this.apiService.voucherpostingexport(this.pdfdata).subscribe(response => {
          const downloadUrl = response[0];
          const blob = new Blob([response], { type: 'application/pdf' });
          const downloadLink = document.createElement('a');
          const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
          downloadLink.href = downloadUrl;
          downloadLink.download = filename;
          downloadLink.target = '_blank';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }, error => {
          console.error('Error sending data:', error);
        });
      },
      error => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  openingTrialBalance() {
    this.apiService.getopeningTrialBalance().subscribe(
      (response) => {
        this.obdata = response.data;
        const branches = this.access_list[0]?.branches || [];
        const matchingObdata = this.obdata.filter(item => branches.includes(item.branch_id));
        this.branchNames = matchingObdata.map(item => item.branch.name);
        console.log('match banchs', this.branchNames);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  companyDetails() {
    this.apiService.Companydetails(this.hostname).subscribe(
      (response) => {
        this.enforce_match = response.is_enforce_match_ob;
        this.company_wise = response.is_company_wise;
        this.branch_wise = response.is_branch_wise;
        if (this.enforce_match == 1 && this.company_wise == 1) {
          this.name = 'Company';
          this.is_show = true;
        } else if (this.enforce_match == 1 && this.branch_wise == 1) {
          if (this.branchNames.length != 0) {
            this.name = this.branchNames;
            this.is_show = true;
          } else {
            this.is_show = false;
          }
        } else {
          this.is_show = false;
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  onScroll(event: any): void {
    const element = event.target;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
  
    const scrolledRatio = scrollPosition / totalHeight;
  
    console.log("Scrolled Ratio:", scrolledRatio);
    console.log("isLoading:", this.loading);
    console.log("hasMoreData:", this.hasMore);
  
    if (scrolledRatio > 0.5 && !this.loading && this.hasMore) {
      console.log("Calling fetchData()");
      this.fetchData();
    }
  }
  sortData(column: string) {
    const columnIndex = this.sortColumns.indexOf(column);
    if (columnIndex !== -1) {
      this.sortDirections[columnIndex] = this.sortDirections[columnIndex] === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumns.push(column);
      this.sortDirections.push('asc');
    }
    this.offset = 0;
    this.data = [];
    this.fetchData(true, this.sortColumns, this.sortDirections);
  }
  resetFilters(): void {
    this.sortColumns = [];
    this.sortDirections = [];
    this.offset = 0;
    this.data = [];
    this.hasMore = true;
    this.fetchData();
  }
  fetchAllData(): void {
    this.loading = true;
    this.offset = 1; 
    this.hasMore = false; 
      const container = document.querySelector('.scroll-box');
      if (container) {
        const observer = new MutationObserver(() => {
          container.scrollTop = container.scrollHeight;
          observer.disconnect(); 
        });
        observer.observe(container, {childList: true, subtree: true });
      }
    this.apiService.getAllpostedvoucher({},true).subscribe(
      (response) => {
        this.data=response.posted_voucher; 
        this.loading = false;
        if (this.isModal && this.tracedVoucherId) {
          // Find the traced voucher in the data
          const tracedIndex = this.data.findIndex((v: any) =>
            v.id == this.tracedVoucherId || v.creation_voucher_id == this.tracedVoucherId
          );
          if (tracedIndex !== -1) {
            // Move it to the top
            const tracedVoucher = this.data.splice(tracedIndex, 1)[0];
            this.data.unshift(tracedVoucher);
            this.injectedVoucherOnce = true;
            console.log('Pinned traced voucher to top:', this.tracedVoucherId);
          }
        }

        this.form = this.data.length > 0;
        this.form1 = !this.form;
        if (this.isModal && this.tracedVoucherId) {
          setTimeout(() => {
            if (this.data.length > 0 && (this.data[0].id == this.tracedVoucherId || this.data[0].creation_voucher_id == this.tracedVoucherId)) {
              this.toggleExpand(this.data[0]);
            }
            this.scrollToHighlightedRow();
          }, 300);
        }
       console.log('All data fetched successfully:', this.data);
      },
      (error) => {
        this.loading = false;
        console.error('Error fetching all data:', error);
      }
    );
  }
  audit(voucher_posting_id: any,i:any) {
    const dialogRef = this.dialog.open(AuditDialogComponent, {
      width: '400px',
      data: {
        voucher_posting_id: voucher_posting_id,
      }
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
          console.log('Saved Voucher:', confirmed);
          const updatedVoucher = this.data[i];
           console.log('specific posted voucher',updatedVoucher);
           if (!updatedVoucher.audit) {
             updatedVoucher.audit = {
               audit_status: null,
               remark: null
             };
           }
           updatedVoucher.is_audit=confirmed.audit;
           updatedVoucher.audit.audit_status = confirmed.audit;
           updatedVoucher.audit.remark = confirmed.remark;
      }
    });
  }
  async toggleExpand(item: any) {
    const response = await this.handleVoucherExpand(item.id,item.creation_voucher_id,item.voucher.voucher_type);
    if (response) {
      if (response.voucher_credit) {
        item.voucher_credit = response.voucher_credit;
      }
      if (response.voucher_debit) {
        item.voucher_debit = response.voucher_debit;
      }
    }
    item.expanded = !item.expanded;
  }
  handleVoucherExpand(voucher_id: number,creation_voucher_id: number,voucher_type: string): Promise<any> {
    return this.apiService.getVoucherPostingDetails(voucher_id,creation_voucher_id,voucher_type).toPromise()
      .then((response) => {
        console.log('Voucher posting details:', response);
        return response;
      })
      .catch((error) => {
        console.error('Error fetching voucher posting details:', error);
        throw error;
      });
  }
  getVoucherDetail(details: any[], type: 'GRN' | 'GSN', field: 'NO' | 'NAME'): string {
    if (!details) return '';
    const isGrn = type === 'GRN';
    const list = details
      .filter(d => isGrn ? d?.grn : d?.gsn)
      .map(d => {
        if (field === 'NO') {
          return isGrn ? d.grn?.grn_no : d.gsn?.gsn_no;
        } else {
          return isGrn ? d.vendor?.vendor_name : d.customer?.customer_name;
        }
      })
      .filter(x => x);
    return [...new Set(list)].join(', ');
  }
  scrollToHighlightedRow() {
    setTimeout(() => {
      const el = document.getElementById('voucher-' + this.tracedVoucherId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 500);
  }

  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  onBranchOpen(opened: boolean) {
  if (!opened) return;

  this.branch_offset = 0;
  this.branch_hasMore = true;
  this.branch_list = [];

  this.getBranches();
}

onBranchScroll() {
  if (this.branch_loading || !this.branch_hasMore) return;
  this.getBranches();
}
onBranchSearch(term: string) {
  this.branchSearch = term;
  this.branch_offset = 0;
  this.branch_hasMore = true;
  this.branch_list = [];

  this.getBranches();
}

getBranches() {
  if (this.branch_loading || !this.branch_hasMore) return;

  this.branch_loading = true;

  const params = {
    type: 'lazyloading',
    offset: this.branch_offset,
    limit: this.branch_limit,
    search: this.branchSearch || ''
  };

  this.apiService.getDatabranch(params).subscribe({
    next: (res: any) => {
     const data = res?.branch_data ?? [];

      this.branch_list = [...this.branch_list, ...data];
      console.log('Branch List:', this.branch_list);
      this.branch_offset += data.length;
      this.branch_hasMore = data.length === this.branch_limit;
      this.branch_loading = false;
    },
    error: () => {
      this.branch_loading = false;
    }
  });
}
  onLedgerOpen(opened: boolean) {
  if (!opened) return;

  this.ledger_offset = 0;
  this.ledger_hasMore = true;
  this.ledger_list = [];

  this.getLedger();
}
onLedgerScroll() {
  if (this.ledger_loading || !this.ledger_hasMore) return;
  this.getLedger();
}
onLedgerSearch(term: string) {
  this.searchTerm = term;
  this.ledger_offset = 0;
  this.ledger_hasMore = true;
  this.ledger_list = [];

  this.getLedger();
}

getLedger() {
  if (this.ledger_loading || !this.ledger_hasMore) return;

  this.ledger_loading = true;

  this.apiService.getDataLedger(
    this.filters,
    1,
    this.ledger_limit,
    this.ledger_offset,
    '',
    this.searchTerm,
    'ledgerindex',
    false
  ).subscribe({
    next: (res: any) => {
      const ledgerData = res?.ledger_data ?? [];

      this.ledger_list = [
        ...this.ledger_list,
        ...ledgerData
      ];

      this.ledger_offset += ledgerData.length;
      this.ledger_hasMore = ledgerData.length === this.ledger_limit;

      this.ledger_loading = false;
    },
    error: () => {
      this.ledger_loading = false;
    }
  });
}
onSearch() {
  this.isSearch = true;
  this.noRecords = false;
  this.offset = 0;
  this.hasMore = true;
  this.data = [];

  this.fetchData();
}
applySearch(term: string) {
  this.searchTerm = term;
  this.onSearch(); 
}
  getCreditBranchNames(branch: any): string {
    if (!branch) return '';
    if (Array.isArray(branch)) {
      return branch
        .map(item => item?.branch_name || item)
        .filter((name, index, self) => name && self.indexOf(name) === index)
        .join(', ');
    }
    return branch.branch_name || branch.toString();
  }
}

